import styled from 'styled-components'
import { LIGHTEST_GRAY } from 'components/styles'

export const DividerHorizontal = styled.div`
  height: 1px;
  background-color: ${LIGHTEST_GRAY};
  width: 100%;
`

export const DividerVertical = styled.div`
  height: 100%;
  background-color: ${LIGHTEST_GRAY};
  width: 1px;
`



// WEBPACK FOOTER //
// ./src/components/shared/Divider.js